var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModifica(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.67 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.65,1.46a6.94,6.94,0,0,0-9.73,1.21L14.81,19.51a1,1,0,0,0-.21.53L13.66,30.9a1,1,0,0,0,.38.89,1,1,0,0,0,1,.15l10.3-3.57a1,1,0,0,0,.46-.34L38.86,11.19A6.94,6.94,0,0,0,37.65,1.46ZM36.41,3.05A4.93,4.93,0,0,1,37.27,10l-.36.46-7.76-6,.36-.47A4.93,4.93,0,0,1,36.41,3.05ZM15.8,29.53l.69-8,6.85,5.34Z",
    transform: "translate(-13.65 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifica);
export default __webpack_public_path__ + "static/media/modifica.590593fa.svg";
export { ForwardRef as ReactComponent };